import { Department, handleAxiosError } from 'data';
import { getPracticeDepartments, getDepartmentDetails } from '../../services/department-management';

export const fetchDepartmentsApi = async (organisationId: string): Promise<Department[]> => {
  try {
    const result = await getPracticeDepartments(organisationId);
    const departmentsData = result?.practiseDepartments || [];

    const enrichedDepartments: Department[] = await Promise.all(
      departmentsData.map(
        async (dept: {
          id: string;
          description: string | null;
          type: string;
          parentDepartmentId?: string | null;
        }) => {
          const details = await getDepartmentDetails(dept.id);

          return {
            id: dept.id,
            description: dept.description ?? null,
            type: dept.type,
            name: details?.name || 'Unknown Department',
            parentDepartmentId: dept.parentDepartmentId ?? null
          };
        }
      )
    );

    return enrichedDepartments;
  } catch (error) {
    throw new Error(handleAxiosError(error));
  }
};
